import { render, staticRenderFns } from "./structured-learning-modal.vue?vue&type=template&id=442b0cd8&scoped=true"
import script from "./structured-learning-modal.vue?vue&type=script&lang=js"
export * from "./structured-learning-modal.vue?vue&type=script&lang=js"
import style0 from "./structured-learning-modal.vue?vue&type=style&index=0&id=442b0cd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442b0cd8",
  null
  
)

export default component.exports